import React, { useEffect, Suspense, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { withErrorBoundary } from 'react-error-boundary';

import {
	authenticationActions,
	messageActions,
	authenticationSelectors,
} from 'Ducks';
import PageLoading from 'Components/Globals/PageLoading/index';
import ToastsWrapper from 'Components/Globals/ToastsWrapper';
import ServicesProvider from '../ServicesProvider';
import routes from 'Pages/router/constants/routes';
import usePathname from 'Hooks/usePathname';
import Router from 'Pages/router';
import { ErrorPage } from 'Pages';

const PageProvider = (props) => {
	const {
		className,
		isAuthenticated,
		isAppInitializing,
		appInit,
		clearToasts,
	} = props;

	const pathname = usePathname();
	const navigate = useNavigate();
	const [initCalled, setInitCalled] = useState(false);

	useEffect(() => {
		if (initCalled) return;

		setInitCalled(true);
		if (isAuthenticated) {
			if ([routes.login, routes.signup].includes(pathname)) {
				navigate(routes.dashboard, { replace: true });
			}
			return;
		}
		appInit({ navigate, pathname });
	}, [isAuthenticated, navigate, pathname, appInit, initCalled]);

	useEffect(() => {
		clearToasts();
	}, [pathname, clearToasts]);

	if (isAppInitializing && !isAuthenticated) {
		return (
			<div className={className}>
				<PageLoading />
			</div>
		);
	}

	return (
		<div className={className}>
			<Suspense fallback={<PageLoading />}>
				<ServicesProvider>
					<div>
						<Router />
						<ToastsWrapper />
					</div>
				</ServicesProvider>
			</Suspense>
		</div>
	);
};

PageProvider.defaultProps = {
	className: '',
};

PageProvider.propTypes = {
	isAuthenticated: PropTypes.bool,
	isAppInitializing: PropTypes.bool,
	appInit: PropTypes.func,
	clearToasts: PropTypes.func,
	className: PropTypes.string,
};

const mapStateToProps = (state) => {
	return {
		isAuthenticated: authenticationSelectors.selectAuthenticated(state),
		isAppInitializing: authenticationSelectors.selectAppInitializing(state),
	};
};

const mapDispatchToProps = {
	appInit: authenticationActions.appInitRequest,
	clearToasts: messageActions.clearNonPersistantToasts,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(
	withErrorBoundary(PageProvider, {
		FallbackComponent: (props) => <ErrorPage {...props} />,
		onError: (error) => {
			console.error(error);
		},
	})
);
